// src/components/CtaContainer.jsx
import React from "react";
import { Link } from "react-router-dom";


export default function CtaContainer() {
  return (
    <section className="cl-cta" id="contact">
      <div className="cl-cta-inner">
        <h2 className="cl-cta-title">Ready to Simplify Your Legal Work?</h2>
        <p className="cl-cta-sub">
          Get matched with verified lawyers and manage your legal services—all in one place.
        </p>
        <div className="cl-cta-actions">
          <Link to="/plans/personal" className="btn-cta-solid">View Plans</Link>
          <Link to="/contact" className="btn-cta-outline">Contact Us</Link>
          </div>
      </div>

      {/* curved bottom */}
      <div className="cl-cta-wave" aria-hidden="true">
        <svg viewBox="0 0 1440 180" preserveAspectRatio="none">
          <path d="M0,40 C240,140 480,180 720,180 C960,180 1200,140 1440,40 L1440,180 L0,180 Z"></path>
        </svg>
      </div>
    </section>
  );
}
